<!--
 * @Author: Zyr
 * @Date: 2021-01-07 17:43:53
 * @LastEditTime: 2021-01-11 10:39:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\components\Account\comMainInfo.vue
-->

<template>
    <div class="card-fa-div">
        <el-card class="box-card" style="width: 100%; height:750px;">
        <el-row>
            <h1 style="float:left">基本信息</h1>
        </el-row> 
        <div style="font-size:20px"> 
            <el-row>
                <el-col :span="16" :offset="5">
                    <div class="account-info-title">姓名：{{$store.state.userName}}</div>
                    <div class="account-info-title">邮箱：{{}}</div>
                    <div class="account-info-title">手机号：{{}}</div>
                    
                    <div class="account-info-title">密码：<el-button @click="goto_change_password">修改密码</el-button></div>
                    
                </el-col>
                
              </el-row>    
        </div>
      </el-card>
    </div>


</template>

<script>


export default {
    name:'comMainInfo',
    data(){
      return{
        

       
                    
      }
    },

  components: {
    
  },

    mounted(){
      
    },

    methods:{
        goto_change_password(){
            this.$store.state.isMainInfo = false
            this.$store.state.isChangePassword = true
            this.$store.state.menu_opened = ['1']
            this.$store.state.menu_active = '修改密码'
        },

    }

}
</script>

<style scoped>
.account-info-title{
    margin: 20px 0px;
    text-align: left;
}
.account-info-content{
    margin: 10px 0px;
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Account/comMainInfo.vue